export enum PedidosActionTypeEnum {
    LISTAR_PEDIDOS = 'LISTAR_PEDIDOS'
}